import React from 'react';
import { MapPinIcon, UsersIcon } from 'lucide-react';
import { Stars } from '../Stars';
import { moreTestimonials } from '../../data/landing';
export function MoreTestimonials() {
  return <section className="bg-ink px-5 py-16 md:py-24" data-id="element-187" data-mp="2bnwtsc7u8qv0">
      <div className="mx-auto mb-10 flex w-fit flex-col items-center gap-4 rounded-full border border-line bg-surface px-6 py-3 sm:flex-row sm:gap-5" data-id="element-188" data-mp="2bmbygkdp93w3">
        <div className="flex -space-x-3" aria-hidden="true" data-id="element-189" data-mp="22o0civns2u9z">
          {moreTestimonials.map(t => <span key={t.initials} className="flex h-10 w-10 items-center justify-center rounded-full bg-line text-xs font-black text-heading ring-2 ring-surface" data-id="element-190" data-mp="1xx1r5hnxn5zv">
              {t.initials}
            </span>)}
          <span className="flex h-10 w-10 items-center justify-center rounded-full bg-success text-xs font-black text-ink ring-2 ring-surface" data-id="element-191" data-mp="1nz44gylq1h9d">
            +3k
          </span>
        </div>
        <div className="flex flex-col items-center sm:items-start" data-id="element-192" data-mp="1ey61mjn0rfsd">
          <div className="flex items-center gap-2" data-id="element-193" data-mp="1f00jfp2zurs8">
            <Stars className="h-4 w-4" data-id="element-194" data-mp="3v89q5p8v00tm" />
            <span className="text-sm font-black text-heading" data-id="element-195" data-mp="3v7812gv0ddsw">4.9/5</span>
          </div>
          <p className="text-sm font-semibold text-body" data-id="element-196" data-mp="3vy8619vnb34">
            +3.000 personas rescatadas del scroll
          </p>
        </div>
      </div>
      <h2 className="flex items-center justify-center gap-3 text-center text-3xl font-black uppercase tracking-tight text-heading md:text-5xl" data-id="element-197" data-mp="3q9ydl6r6jc7p">
        <UsersIcon className="h-8 w-8 shrink-0 text-success" aria-hidden="true" data-id="element-198" data-mp="huxwf7th9nyr" />
        +3.000 personas ya lo tienen
      </h2>
      <div className="mx-auto max-w-6xl" data-id="element-199" data-mp="mr54p79cjbjv">
        <div className="mt-12 grid gap-5 sm:grid-cols-2" data-id="element-200" data-mp="8uhz6g3bvd2c">
          {moreTestimonials.map(t => <figure key={t.author} className="flex flex-col rounded-3xl border border-line bg-surface p-7" data-id="element-201" data-mp="cusbeahpqzpn">
              <div className="flex items-center gap-4" data-id="element-202" data-mp="2tjpf1opzi6jf">
                <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-full border border-line bg-ink text-base font-black text-heading" data-id="element-203" data-mp="2tmbmlocvkm1n">
                  {t.initials}
                </span>
                <div data-id="element-204" data-mp="z3quincdoaql">
                  <p className="font-extrabold text-heading" data-id="element-205" data-mp="z3gyai0qp7cg">{t.author}</p>
                  <p className="flex flex-wrap items-center gap-x-2 text-sm text-body" data-id="element-206" data-mp="ud0iwsdczbng">
                    <span className="flex items-center gap-1" data-id="element-207" data-mp="uany87g7un6p">
                      <MapPinIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-208" data-mp="pde7moh3c5ha" /> {t.city}
                    </span>
                    <span aria-hidden="true" data-id="element-209" data-mp="ldn89wdi0h15">·</span>
                    {t.tag}
                  </p>
                </div>
              </div>
              <div className="mt-5" data-id="element-210" data-mp="bdmn04w2jqub">
                <Stars data-id="element-211" data-mp="beobpc60cbui" />
              </div>
              <blockquote className="mt-3 text-lg leading-relaxed text-body" data-id="element-212" data-mp="6f32m8x4in42">“{t.quote}”</blockquote>
            </figure>)}
        </div>
      </div>
    </section>;
}